import { createActions, createReducer } from 'reduxsauce'

import DetalhesFornecedoresItemService from '../../servicos/DetalhesAtaRegistroPrecoService'

/**
 * Action types & creators
 */
export const { Types, Creators } = createActions({
    buscaDetalhesFornecedoresItemInicio: [],
    buscaDetalhesFornecedoresItemSucesso: ['detalhesFornecedoresItem'],
    buscaDetalhesFornecedoresItemErro: ['erro'],
})

const INITIAL_STATE = {
    carregando: false,
    erro: null,
    lista: [],
}

// Ação para busca completa
Creators.buscaDetalhesFornecedoresItem = filtro => {
    return dispatch => {
        dispatch(Creators.buscaDetalhesFornecedoresItemInicio())
        let serv = new DetalhesFornecedoresItemService()
        return serv
            .consultarDetalhesFornecedoresItem(filtro)
            .then(response => dispatch(Creators.buscaDetalhesFornecedoresItemSucesso(response.data)))
            .catch(error => dispatch(Creators.buscaDetalhesFornecedoresItemErro(error)))
    }
}

const buscaDetalhesFornecedoresItemInicio = (state = INITIAL_STATE, action) => {
    return { ...state, carregando: true, erro: null }
}

const buscaDetalhesFornecedoresItemErro = (state = INITIAL_STATE, action) => {
    return { ...state, erro: action.erro, carregando: false }
}

const buscaDetalhesFornecedoresItemSucesso = (state = INITIAL_STATE, action) => {
    return { ...state, lista: action.detalhesFornecedoresItem, carregando: false }
}

/**
 * Reducer
 */
export default createReducer(INITIAL_STATE, {
    [Types.BUSCA_DETALHES_FORNECEDORES_ITEM_INICIO]: buscaDetalhesFornecedoresItemInicio,
    [Types.BUSCA_DETALHES_FORNECEDORES_ITEM_ERRO]: buscaDetalhesFornecedoresItemErro,
    [Types.BUSCA_DETALHES_FORNECEDORES_ITEM_SUCESSO]: buscaDetalhesFornecedoresItemSucesso,
})
